import { render } from "./infoCard_final.vue?vue&type=template&id=e3949c90"
import script from "./infoCard_final.vue?vue&type=script&lang=js"
export * from "./infoCard_final.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__